import React, { useRef } from "react";
import emailjs from "@emailjs/browser";

export default function Home() {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm("service_8a12t5g", "template_khha018", form.current, {
        publicKey: "pSctHomQyiu0sgEMC",
      })
      .then(
        () => {
          alert("✅ Appointment request sent successfully!");
        },
        (error) => {
          alert("❌ Failed to send. Please try again later.");
          console.log("FAILED...", error.text);
        }
      );
  };

  return (
    <div className="p-6 text-center bg-green-50 min-h-screen">
      <h2 className="text-4xl text-green-700 font-bold mb-4">
        Welcome to HerbArtz Siddha Ayurvedic Clinic
      </h2>
      <p className="text-lg text-gray-700 mb-6">
        Your trusted Ayurvedic clinic in Batticaloa. <br />
        Officially registered private clinic under the Department of Ayurveda,
        Sri Lanka.
      </p>

      <img
        src="/images/ayurveda-hero.jpg"
        alt="Ayurveda Practice"
        className="mt-4 rounded-2xl mx-auto shadow-lg w-full max-w-xl"
      />

      {/* Introduction Section */}
      <div className="mt-10">
        {/* <h3 className="text-2xl font-semibold text-green-800 mb-2">What is Ayurveda?</h3> */}
        <p className="text-md text-gray-700 max-w-2xl mx-auto">
          Whether you’re seeking relief from disease conditions, lifestyle guidance, or natural cosmetic solutions, we offer individualized treatments rooted in classical indigenous medical principles.
        </p>
        <p className="text-md text-gray-700 max-w-2xl mx-auto">
          Patient Privacy & Confidentiality: We are committed to maintaining the highest standards of patient privacy and confidentiality.
        </p>
      </div>

      {/* Services Section */}
      <div className="mt-12">
        <h3 className="text-2xl font-semibold text-green-800 mb-6">Our Key Treatments</h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto">

          <div className="bg-white p-4 rounded-xl shadow-md">
            <img src="/images/Internal_medicines.jpg" alt="Internal medicines" className="rounded-md mb-3" />
            <h4 className="text-xl font-medium text-green-700">Internal medicines</h4>
            <p className="text-sm text-gray-600">HerbArtz provides internal Siddha and Ayurvedic medicines aimed at balancing vitiated doshas, promoting healing, and restoring overall health and well-being. These medicines are prescribed based on individual consultation and are available in various classical forms such as decoctions, powders, tablets and more. Each formulation is selected to suit the patient’s unique constitution (prakriti) and condition, supporting deep, natural healing from within.</p>
          </div>

          <div className="bg-white p-4 rounded-xl shadow-md">
            <img src="/images/Puravalaiya_sikichai.jpg" alt="Puravalaiya sikichai" className="rounded-md mb-3" />
            <h4 className="text-xl font-medium text-green-700">Puravalaiya sikichai (Oil pooling in dough)</h4>
            <p className="text-sm text-gray-600">Specialized treatment where warm medicated oil is retained in a dough ring placed over a specific area. It helps relieve pain, stiffness, inflammation, and improve circulation in targeted region. It promotes healing and restores mobility.</p>
          </div>

          <div className="bg-white p-4 rounded-xl shadow-md">
            <img src="/images/Ottradam.jpg" alt="Ottradam" className="rounded-md mb-3" />
            <h4 className="text-xl font-medium text-green-700">Ottradam (Fomentation)</h4>
            <p className="text-sm text-gray-600">Involves applying warm herbal preparations to relieve pain, stiffness, swelling, and muscle spasms.</p>
          </div>

          <div className="bg-white p-4 rounded-xl shadow-md">
            <img src="/images/Seelai.jpg" alt="Seelai" className="rounded-md mb-3" />
            <h4 className="text-xl font-medium text-green-700">Seelai (Medicated gauze)</h4>
            <p className="text-sm text-gray-600">Involves using gauze or cloth soaked in herbal medications and applying it directly over the specific area. It helps reduce stiffness, relieve pain and promote healing.</p>
          </div>

          <div className="bg-white p-4 rounded-xl shadow-md">
            <img src="/images/Varmam.jpg" alt="Varmam" className="rounded-md mb-3" />
            <h4 className="text-xl font-medium text-green-700">Varma & Thokkanam</h4>
            <p className="text-sm text-gray-600">Specific Siddha treatment focuses on stimulation and manipulation of specific vital energy points in the body. By applying controlled pressure on these points, Varma therapy helps to restore energy flow, relieve pain, improve organ function, and treat various neuromuscular, orthopedic, and psychosomatic disorders.</p>
          </div>

          <div className="bg-white p-4 rounded-xl shadow-md">
            <img src="/images/Patru.jpg" alt="Patru" className="rounded-md mb-3" />
            <h4 className="text-xl font-medium text-green-700">Patru (Poultice) & Kattu (Bandage)</h4>
            <p className="text-sm text-gray-600">Traditional healing methods used to manage pain, inflammation, and wounds. A poultice involves applying a warm, herbal paste directly to the affected area to draw out toxins, reduce swelling, and promote healing. It is often followed by bandaging, which helps secure the poultice in place, provides support, and protects the area from further injury or infection.</p>
          </div>

          <div className="bg-white p-4 rounded-xl shadow-md">
            <img src="/images/Vethu_Pugai.jpg" alt="Patru" className="rounded-md mb-3" />
            <h4 className="text-xl font-medium text-green-700">Vethu (Steam therapy) & Pugai (Fumigation)</h4>
            <p className="text-sm text-gray-600">Helps to relieve pain, stiffness, and respiratory issues. Steam therapy involves applying herbal steam to the body or affected area using medicinal herbs. Fumigation therapy is exposing specific area to medicated smoke. It helps open skin pores, improve circulation, remove toxins and enhance absorption of herbal medications.</p>
          </div>

          <div className="bg-white p-4 rounded-xl shadow-md">
            <img src="/images/cupping.jpg" alt="Cupping Therapy" className="rounded-md mb-3" />
            <h4 className="text-xl font-medium text-green-700">Cupping Therapy</h4>
            <p className="text-sm text-gray-600">Cupping therapy is a traditional healing practice that involves placing cups on the skin to create suction. This suction promotes blood flow, reduces inflammation, and encourages healing. The therapy is often used to relieve muscle tension, pain, and stiffness.</p>
          </div>

          <div className="bg-white p-4 rounded-xl shadow-md">
            <img src="/images/Knee-Joint-Pain.jpg" alt="Knee Joint Pain" className="rounded-md mb-3" />
            <h4 className="text-xl font-medium text-green-700">Knee Joint Pain</h4>
            <p className="text-sm text-gray-600">Our holistic approach target the root cause of your pain, & promoting long-lasting wellness and mobility.</p>
          </div>
          <div className="bg-white p-4 rounded-xl shadow-md">
            <img src="/images/Back-Pain.jpg" alt="Back Pain" className="rounded-md mb-3" />
            <h4 className="text-xl font-medium text-green-700">Back Pain</h4>
            <p className="text-sm text-gray-600">Harnessing the ancient wisdom, our treatment are tailored to address the root cause of your pain.</p>
          </div>
          
          <div className="bg-white p-4 rounded-xl shadow-md">
            <img src="/images/nashyam.jpg" alt="Cupping Therapy" className="rounded-md mb-3" />
            <h4 className="text-xl font-medium text-green-700">Nashyam</h4>
            <p className="text-sm text-gray-600">Administration of herbal medication through nasal passage.</p>
          </div>
          

          <div className="bg-white p-4 rounded-xl shadow-md">
            <img src="/images/Cosmetic-Products.jpg" alt="Cosmetic Products" className="rounded-md mb-3" />
            <h4 className="text-xl font-medium text-green-700">Cosmetic Products</h4>
            <p className="text-sm text-gray-600">Providing natural & handcrafted cosmatic procucts(Herbal Hair Oil, Wellness Soap, Lip Balm...).</p>
          </div>

        </div>
      </div>

      {/* Testimonials Section */}
      {/* <div className="mt-16">
        <h3 className="text-2xl font-semibold text-green-800 mb-6">What Our Patients Say</h3>
        <div className="max-w-3xl mx-auto text-gray-700 italic">
          <p>"Herbartz changed my life. The herbal treatments and kind care brought me back to health naturally!"</p>
          <p className="text-sm mt-2 text-gray-500">— Anjali S., Batticaloa</p>
        </div>
      </div> */}

      {/* Appointment Reservation Section */}
      <div className="mt-16 bg-white rounded-xl shadow-md p-6 max-w-3xl mx-auto">
        <h3 className="text-2xl font-semibold text-green-800 mb-4">
          Book an Appointment
        </h3>
        <p className="text-gray-700 mb-6">
          Schedule your consultation with our experienced Ayurvedic
          practitioners. Choose a time that works best for you.
        </p>
        <p className="text-gray-700 mb-6">
          Please Call/Whatsapp : +94 76 430 0539
        </p>

        {/* EmailJS Integrated Form */}
        <form ref={form} onSubmit={sendEmail} className="grid grid-cols-1 gap-4 md:grid-cols-2">
          <input
            type="text"
            name="user_name"
            placeholder="Full Name"
            className="p-2 border border-gray-300 rounded-md"
            required
          />
          <input
            type="email"
            name="user_email"
            placeholder="Email Address"
            className="p-2 border border-gray-300 rounded-md"
            required
          />
          <input
            type="tel"
            name="user_phone"
            placeholder="Phone Number"
            className="p-2 border border-gray-300 rounded-md"
            required
          />
          <input
            type="date"
            name="appointment_date"
            className="p-2 border border-gray-300 rounded-md"
            required
          />
          <textarea
            name="message"
            placeholder="Your health concern or message"
            className="col-span-2 p-2 border border-gray-300 rounded-md h-24"
          ></textarea>
          <button
            type="submit"
            className="col-span-2 bg-green-600 text-white py-2 px-4 rounded-md hover:bg-green-700 transition"
          >
            Reserve Appointment
          </button>
        </form>
      </div>
    </div>
  );
}